import script from "./SmcModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmcModal.vue?vue&type=script&lang=ts&setup=true"

import "./SmcModal.vue?vue&type=style&index=0&id=1dbb1e6c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbb1e6c"]])

export default __exports__